module.exports = __webpack_public_path__ + "static/img/18.8594adc9.png";